// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_9j-0";
export var orangeButton = "_9j-1";